package one.healthium.onboarding.ui

import one.healthium.domain.user.models.UserProfileModel
import one.healthium.onboarding.domain.models.GenderText
import one.healthium.onboarding.domain.models.SelectableOption
import one.healthium.onboarding.ui.models.HeightUnit
import one.healthium.onboarding.ui.models.WeightUnit

internal class UserUiMapper {

    fun toUiModel(model: UserProfileModel, isMetric: Boolean): UserProfileUiModel {
        return UserProfileUiModel(
            name = model.name ?: "",
            age = model.age,
            weight = model.weight,
            selectedWeightUnit = if (isMetric) WeightUnit.Kg else WeightUnit.Lb,
            targetWeight = model.targetWeight,
            selectedTargetWeightUnit = if (isMetric) WeightUnit.Kg else WeightUnit.Lb,
            height = model.height,
            gender = model.gender,
            selectedHeightUnit = if (isMetric) HeightUnit.Cm else HeightUnit.Ft,
            additionalInfo = model.additionalInfo.mapValues { (_, value) ->
                value.map { additionalUserInfoModel ->
                    SelectableOption(
                        key = additionalUserInfoModel.key,
                        text = GenderText(additionalUserInfoModel.text, additionalUserInfoModel.text),
                        altText = additionalUserInfoModel.altText,
                    )
                }
            },
            statements = model.statements,
            isMetric = isMetric,
        )
    }

    fun toModel(uiModel: UserProfileUiModel): UserProfileModel {
        return uiModel.model
    }
}